export interface LocalSearchPoi {
  value: string;
  label: string;
}

export const searchLocalPois = (
  map: any,
  keyword: string,
  onComplete: (list: LocalSearchPoi[]) => void
) => {
  const searchText = keyword?.trim();
  if (!searchText || !map || !window.BMapGL) {
    return;
  }
  const local = new window.BMapGL.LocalSearch(map, {
    onSearchComplete: (result: any) => {
      const list: LocalSearchPoi[] = [];
      const seen = new Set<string>();
      const poiCount = result?.getNumPois?.() ?? 0;
      for (let i = 0; i < poiCount; i++) {
        const poi = result.getPoi(i);
        if (!poi?.point) {
          continue;
        }
        const coordKey = `${poi.point.lng},${poi.point.lat}`;
        // 按坐标去重，避免重复 key 警告
        if (seen.has(coordKey)) {
          continue;
        }
        seen.add(coordKey);
        list.push({
          value: coordKey,
          label: poi.title,
        });
      }
      onComplete(list);
    },
  });
  local.search(searchText);
};
